import type { App } from 'vue'
import { Icon } from './Icon'
import { Card, BlockCard } from './Card'
import { Collapse } from './Collapse'
import { Button } from './Button'
import { Dialog } from './Dialog'
import { Pagination } from './Pagination'
import { CTooltip } from './CTooltip'
import { CProgress } from './CProgress'
import { CLoading } from './CLoading'
import { Percentage } from './Percentage'
import { FormItem } from './FormItem'
import { Colors,ColorPicker } from './Colors'
import { Splitter, SplitterPanel } from './Splitter'
import { CodemirrorInput } from './CodemirrorInput'
import { ColorsSelector } from './ColorsSelector'
import { EChartPosition } from './EChartPosition'
import { ValueMapping } from './ValueMapping'
export const setupGlobCom = (app: App<Element>): void => {
  app.component('Icon', Icon)
  app.component('Card', Card)
  app.component('BlockCard', BlockCard)  
  app.component('Collapse', Collapse)
  app.component('Button', Button)
  app.component('Dialog', Dialog)
  app.component('Pagination', Pagination)
  app.component('CTooltip', CTooltip)
  app.component('CProgress', CProgress)
  app.component('CLoading', CLoading)
  app.component('Percentage', Percentage)
  app.component('FormItem', FormItem)
  app.component('Colors', Colors)
  app.component('ColorPicker', ColorPicker)
  app.component('ColorsSelector', ColorsSelector)
  app.component('EChartPosition', EChartPosition)
  app.component('CodemirrorInput', CodemirrorInput)
    
  app.component('Splitter', Splitter)
  app.component('SplitterPanel', SplitterPanel)

  app.component('ValueMapping', ValueMapping)  
}
